skrilla.directive('fantasyMatches',function() {
    return {
        templateUrl: 'directives/fantasyMatches/fantasyMatches.html',
        scope: {
            season: "=",
            matches: "=",
            onClick: "="
        },
        controller: function($scope, dateService){
            $scope.getLocal = dateService.getLocal;
            $scope.getUTC = dateService.getUnchangedDateToString

            $scope.getColor = function(match){
                return match.state === "COMPLETED" ? "light-green" : match.state === "CANCELLED" ? "light-red" : match.state === "LIVE" ? "light-blue" : null;
            }

        }
    };
});
